import { ActionIcon, Flex, Text, Tooltip } from '@mantine/core';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.tsx';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';

interface Props {
	label: string;
	value: string;
	disabled?: boolean;
}

// v7 Combobox option renderer (was a v6 Select `itemComponent`). Mantine wraps the
// returned node in the option element, so this only renders the option content.
export const UnitDenominatorSelectItem = ({ label, value, disabled }: Props) => {
	const tCapManage = useTranslationCapManage();

	return (
		<Flex
			align="center"
			justify="space-between"
			data-testid={`${TEST_ELEMENT_IDS.CAP_SECURITY_DETAILS_FRACTIONAL_DROPDOWN_OPTION}${value}`}
			sx={() =>
				disabled
					? {
							opacity: 0.5,
							cursor: 'not-allowed',
							background: 'transparent !important',
						}
					: {}
			}
		>
			<Text size="sm">{label}</Text>
			{disabled && (
				<Tooltip
					withinPortal
					label={tCapManage(
						'securities.drawer.fractionalOwnership.denominator_warning_tooltip'
					)}
				>
					<ActionIcon c="dark.4" mih="unset" h="unset" w="unset" miw="unset">
						<Icon variant="information" size="md" />
					</ActionIcon>
				</Tooltip>
			)}
		</Flex>
	);
};
